import { whiteOrBlackTextColor } from "helpers/StyleUtils";
import useWebsiteBuilder, { DividerStyle, WebsiteBuilderContent, WebsiteBuilderStyle } from "Hooks/useWebsiteBuilder";
import { styx } from "modules/Utils";
import { CSSProperties } from "react";

interface DividerPreviewContentProps {
    contentIndex: number;
    websiteContent: WebsiteBuilderContent[];
    websiteStyle: WebsiteBuilderStyle;
    style?: CSSProperties;
    onClickContentBlock?: (index: number) => void;
}

const DividerPreviewContent = ({
    contentIndex,
    websiteContent: websiteContentProp,
    websiteStyle: websiteStyleProp,
    style: styleProp,
    onClickContentBlock,
}: DividerPreviewContentProps) => {
    const {
        websiteContent: websiteContentState,
        websiteStyle: websiteStyleState,
    } = useWebsiteBuilder();

    const websiteContent = websiteContentProp || websiteContentState;
    const websiteStyle = websiteStyleProp || websiteStyleState;

    const { textColor: OLD, backgroundColor } = websiteStyle;

    const isContentTextColorEnabled = websiteContent[contentIndex].isContentTextColorEnabled;
    const contentTextColor = websiteContent[contentIndex].contentTextColor;

    const textColor = isContentTextColorEnabled ? contentTextColor : whiteOrBlackTextColor(backgroundColor);

    const dividerContent = websiteContent[contentIndex].dividerContent;

    const { style } = dividerContent || {};

    const getDividerStyle = () => {
        switch (style) {
            case DividerStyle.SOLID:
                return {
                    outer: null,
                    inner: { borderStyle: 'solid' }
                };
            case DividerStyle.DASHED:
                return {
                    outer: null,
                    inner: { borderStyle: 'dashed' }
                };
            case DividerStyle.SOLID_PADDING:
                return {
                    outer: { paddingLeft: 16, paddingRight: 16 },
                    inner: { borderStyle: 'solid' }
                };
            case DividerStyle.DASHED_PADDING:
                return {
                    outer: { paddingLeft: 16, paddingRight: 16 },
                    inner: { borderStyle: 'dashed' }
                };
            default:
                return {
                    outer: null,
                    inner: null,
                };
        }
    }

    // NOTE: render()
    return (
        <div
            className="dividerPreviewContentComponent"
            style={styx(
                sty.dividerPreviewContentComponent,
                getDividerStyle()?.outer,
                styleProp,
            )}
            onClick={() => onClickContentBlock?.(contentIndex)}
        >
            <div
                className="dividerContent"
                style={styx(
                    sty.dividerContent,
                    getDividerStyle()?.inner,
                    {
                        borderColor: textColor,
                    }
                )}
            />
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    dividerPreviewContentComponent: {
    },
    dividerContent: {
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        width: '100%',
    }
}
export default DividerPreviewContent;